// const IP_URL = "ws://localhost:1300";
const IP_URL = "https://balosh.herokuapp.com";
// const IP_URL = "https://banicoop-server.vercel.app/api/v1";
// s
export default IP_URL;
